import React from 'react';
import jwtDecode from 'jwt-decode';
import { PictureInput } from 'hyperdb-utils';
import api from 'api';
import { FILESTORE_URL } from '../../../../config';

class PictureForm extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    // Dislay edited picture
    const { picture } = this.props;
    const img = document.querySelector('#preview');
    if (picture.original) {
      img.src = this.pictureUrl();
    } else {
      img.style.display = 'none';
    }
  }
  render() {
    const props = this.props;
    return (
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <img src="" alt="preview" id="preview" style={ { maxWidth: '100%', maxHeight: '280px', marginTop: '30px' } } />
        </div>
        <div className="col-sm-12 col-md-6">
          <PictureInput
            title="Picture"
            mode={ this.props.mode }
            picture={ props.picture }
            onChange={ this.handleChangePicture.bind(this) }
            availableLocales={ this.props.availableLanguages }
            defaultLanguage={ this.props.defaultLanguage }
            picturesList={ this.props.picturesList }
          />
          <br/>
          { props.uploadingPicture ? 'UPLOADING...' : '' }
        </div>
      </div>
    );
  }

  pictureUrl() {
    const {picture, object} = this.props;
    const { currentUser } = this.props.api.getState('auth');
    const decoded = jwtDecode(currentUser.jwt);
    if (!picture.original.value) return '';
    return `${FILESTORE_URL}/${decoded.client_id}/properties-files/${object.id}/${picture.original.value.id}/${picture.original.value.name}`;
  }

  handleChangePicture(picture) {
    const file = picture.image_file;
    if (file) {
      readFileToBase64(file)
        .then(result => {
          if (result.content_type.match(/^image\/[png|jpg|jpeg|gif|wepb|svg]/)) {
            displayImage(result);
          }
        });
    }
    this.props.onChange(picture);
  }
}

function readFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      const buffer = e.target.result;
      resolve({
        filename: file.name,
        content_type: file.type,
        size: file.size,
        payload: arrayBufferToString(buffer, 'base64')
      });
    };
    reader.onerror = function(e) {
      reject(e.target.error);
    };
    reader.readAsArrayBuffer(file);
  });
}
function arrayBufferToString(buffer, encoding) {
  encoding = encoding || 'utf-8';
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0, len = bytes.byteLength; i < len; i++) {
    binary += String.fromCharCode( bytes[ i ] );
  }
  switch (encoding) {
  case 'utf-8':
    return new TextDecoder('utf-8').decode(bytes);
  case 'binary':
  case 'ascii':
    return binary;
  case 'base64':
    return window.btoa(binary);
  default:
    throw Error('invalid encoding');
  }
}
function displayImage(data) {
  const imgsrc = 'data:' + data.content_type + ';base64,' + data.payload;
  document.getElementById('preview').src = imgsrc;
  document.getElementById('preview').style.display = 'block';
}

PictureForm.propTypes = {
  api: React.PropTypes.object,
  mode: React.PropTypes.string,
  backendEntryPoint: React.PropTypes.string,
  picture: React.PropTypes.object,
  onChange: React.PropTypes.func,
  uploadingPicture: React.PropTypes.bool,
  availableLanguages: React.PropTypes.array,
};

export default api.connect(PictureForm);



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/common/PictureForm.jsx